<template>
  <div class="teamGroup">
    <div class="left">
      <div class="height50 borderBottom">
        <div class="inline" style="margin-left: 6px">班组列表</div>
        <el-button
          style="margin-top: 9px; margin-right: 6px"
          class="floatRight"
          type="primary"
          size="small"
          @click="addGroupClick"
          >新增分组
        </el-button>
      </div>
      <div class="height50 borderBottom">
        <el-input
          v-model="groupKey"
          style="padding: 0 6px"
          placeholder="请输入分组关键字"
          @input="valueChange($event)"
        ></el-input>
      </div>
      <div class="fzList">
        <div
          class="listItem"
          :class="{ listItemChoose: item.id === selectGroup.id }"
          v-for="(item, index) in filterList"
          :key="index + 'fz'"
          @click="chooseGroup(item)"
        >
          <!-- <img
              style="width: 30px; height: 30px; margin-left: 6px; margin-top: 5px"
              src="@/assets/teamGroup/group_icon.png"
              alt=""
          /> -->
          <!-- <div class="inline el-icon-share" style="margin-left: 6px"></div> -->
          <div
            :title="item.name"
            class="inline"
            style="width: 130px; margin-left: 15px; vertical-align: top"
          >
            {{ item.name }}
          </div>
          <div
            @click.stop="deleteGroupClick(item)"
            style="vertical-align: top; margin-top: 15px"
            class="inline el-icon-delete showDelete"
          ></div>
        </div>
      </div>
    </div>

    <div class="right">
      <div class="info">
        <div>班组信息</div>
        <div style="margin: 10px 0">
          <el-form
            :inline="true"
            :model="selectGroup"
            ref="selectGroup"
            :rules="rules"
            label-position="right"
            label-width="90px"
          >
            <el-row>
              <el-form-item label="班组名称:" prop="name">
                <el-input
                  clearable
                  v-model="selectGroup.name"
                  placeholder="请输入班组名称"
                  @blur="checkName"
                ></el-input>
              </el-form-item>
              <el-button
                type="primary"
                :loading="updateGroupLoading"
                @click="updateGroup(false)"
                >保存
              </el-button>
              <el-form-item label="组长名称:">
                <div @click="addManager" class="manager">
                  <template v-if="leaderList.length > 0">
                    <div
                      class="peopleItem"
                      v-for="(item, index) in leaderList"
                      :key="'zz' + index"
                    >
                      {{ item.name }}
                      <li
                        class="el-icon-error"
                        @click.stop="deleteRow(item, 1)"
                      ></li>
                    </div>
                  </template>

                  <div v-else class="peopleItem">选择组长</div>
                </div>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
      <div>
        <div>组员信息</div>
        <div style="margin: 10px 0">
          <el-row>
            <div class="floatRight">
              <el-input
                style="width: 200px; margin-right: 10px"
                clearable
                v-model="query.employeeInfos"
                placeholder="请输入人员编号或姓名"
                @blur="checkName"
              ></el-input>
              <el-button type="primary" @click="searchPeople">查询</el-button>
            </div>
            <el-button type="primary" @click="addPeople">新增成员</el-button>
          </el-row>
        </div>
        <el-table :data="peopleList" border style="width: 100%">
          <el-table-column
            prop="id"
            label="序号"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column prop="name" label="人员姓名"></el-table-column>
          <el-table-column prop="phone" label="电话号码"></el-table-column>
          <el-table-column prop="sex" label="性别"></el-table-column>
          <el-table-column prop="deptName" label="所在部门"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="deleteRow(scope.row, 0)"
                type="text"
                size="small"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 10px">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      title="新增班组"
      :visible.sync="addGroup"
      width="560px"
      @close="addGroupClose"
    >
      <div class="form">
        <el-form
          :inline="true"
          :model="addForm"
          ref="addForm"
          :rules="rules"
          label-position="right"
          label-width="120px"
        >
          <el-row :gutter="24">
            <el-form-item label="班组名称:" prop="name">
              <el-input
                clearable
                v-model="addForm.name"
                placeholder="请输入班组名称"
                @blur="checkName"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row :gutter="24">
            <el-form-item label="选择班组长:">
              <div style="display: flex; flex-direction: row">
                <el-button @click="openAddGroupManager()">选择班组长</el-button>

                <div
                  v-if="this.selectGroupManagerList.length > 0"
                  style="margin-left: 10px"
                >
                  {{ this.selectGroupManagerList[0].id }}-{{
                    this.selectGroupManagerList[0].name
                  }}
                </div>
              </div>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div class="foot">
        <el-button @click="addGroupClose">取 消</el-button>
        <el-button
          type="primary"
          :disabled="cannoSubmit"
          @click="addGroupSubmit"
          >确 定
        </el-button>
      </div>
      <div style="width: 100%; height: 1px"></div>
    </el-dialog>

    <el-dialog
      title="删除"
      :visible.sync="deleteGroup"
      width="360px"
      @close="deleteGroupClose"
    >
      <div style="margin-bottom: 20px; font-size: 16px; font-weight: 500">
        确定删除 {{ operateGroup.name }} 分组？
      </div>
      <div class="foot">
        <el-button @click="deleteGroupClose">取 消</el-button>
        <el-button type="primary" @click="deleteGroupSubmit">确 定</el-button>
      </div>
      <div style="width: 100%; height: 1px"></div>
    </el-dialog>

    <el-dialog
      title="提醒"
      :visible.sync="tipsVisible"
      width="360px"
      @close="tipClose"
    >
      <div style="margin-bottom: 20px; font-size: 16px; font-weight: 500">
        此页面的内容已经改动，且并未保存，是否保存？
      </div>
      <div class="foot">
        <el-button @click="unSaveInfo">取 消</el-button>
        <el-button type="primary" @click="saveInfo">确 定</el-button>
      </div>
      <div style="width: 100%; height: 1px"></div>
    </el-dialog>

    <!-- 选择班组长 -->
    <add-people
      :addPeopleVisible="addGroupManagerDialogVisible"
      dialogTitle="选择班组长"
      :peopleList="selectGroupManagerList"
      :isLimit="true"
      @closeAddPeopleVisible="closeGroupManagerDialog"
      @submitPeople="submitGroupManager"
    />

    <add-people
      :addPeopleVisible="addPeopleVisible"
      :dialogTitle="dialogTitle"
      :peopleList="selectPeopleList"
      :isLimit="isManager"
      @closeAddPeopleVisible="closeAddPeople"
      @submitPeople="submitPeople"
    ></add-people>
  </div>
</template>

<script>
import TeamGroupApi from '@/api/teamGroup';
import AddPeople from '@/components/AddPeople';

export default {
  name: 'TeamGroup',
  components: {
    AddPeople,
  },
  data() {
    return {
      ///AddPeople组件入参
      dialogTitle: '',
      addPeopleVisible: false,
      selectPeopleList: [],
      ///AddPeople组件入参

      isManager: false,
      groupKey: '',
      addGroup: false,
      deleteGroup: false,
      cannoSubmit: false,
      tipsVisible: false,
      updateGroupLoading: false,
      operateGroup: {},
      nextGroup: {},
      total: 0,
      query: {
        groupId: '',
        employeeInfos: '',
        pageDto: {
          current: 0,
          size: 10,
        },
      },
      addForm: {
        name: '',
      },
      addGroupManagerDialogVisible: false,
      //需要班组长id
      selectGroupManagerList: [],

      groupList: [],
      filterList: [],
      leaderList: [],
      peopleList: [],
      selectGroup: {},

      rules: {
        name: [
          {
            required: true,
            message: '请输入班组名称',
            trigger: ['change', 'blur'],
          },
        ],
      },
    };
  },
  mounted() {
    this.getGroupList();
  },
  methods: {
    ///AddPeople组件回调函数
    closeAddPeople() {
      this.addPeopleVisible = false;
    },
    submitPeople(val) {
      this.addPeopleVisible = false;
      //val返回最终人员名单
      // console.log(val);
      let ids = [];
      val.forEach((item) => {
        ids.push(item.id);
      });
      TeamGroupApi.addGroupEmployee({
        employeeIds: ids,
        groupId: this.selectGroup.id,
        managerMark: this.isManager ? 1 : 0,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success',
          });
          this.getGroupPeople();
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },
    ///AddPeople组件回调函数

    valueChange(keywords) {
      this.filterList = this.seachArray(this.groupList, keywords);
    },

    seachArray(arr, keyword) {
      const newArr = arr.filter((item) => {
        //toUpperCase()将输入内容与对应的字段都转换为大写，这样可以实现不区分大小写，都能搜索到
        return item.name.toUpperCase().includes(keyword.toUpperCase());
      });
      return newArr;
    },
    addManager() {
      this.selectPeopleList = JSON.parse(JSON.stringify(this.leaderList));
      this.addPeopleVisible = true;
      this.isManager = true;
      this.dialogTitle = '选择人员-作为组长';
    },
    addPeople() {
      this.selectPeopleList = JSON.parse(JSON.stringify(this.peopleList));
      this.addPeopleVisible = true;
      this.isManager = false;
      this.dialogTitle = '新增成员';
    },
    saveInfo() {
      this.updateGroup(true);
    },
    unSaveInfo() {
      if (this.nextGroup.id != this.selectGroup.id) {
        this.selectGroup = JSON.parse(JSON.stringify(this.nextGroup));
        this.operateGroup = JSON.parse(JSON.stringify(this.nextGroup));
        this.getGroupPeople();
      }

      this.tipsVisible = false;
    },
    updateGroup(flag) {
      this.updateGroupLoading = true;
      TeamGroupApi.updateGroupInfo({
        id: this.selectGroup.id,
        name: this.selectGroup.name,
      }).then((res) => {
        if (res.data.code === 200) {
          this.getGroupList(flag);
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
        this.updateGroupLoading = false;
      });
    },
    deleteRow(row, mark) {
      TeamGroupApi.deleteEmployeeByGroupId({
        employeeId: row.id,
        groupId: this.selectGroup.id,
        managerMark: mark,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: '移除班组成员成功！',
            type: 'success',
          });
          this.getGroupPeople();
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },
    chooseGroup(item) {
      // console.log(this.operateGroup);
      // console.log(this.selectGroup);
      if (
        this.operateGroup.name != this.selectGroup.name &&
        item.id != this.selectGroup.id
      ) {
        this.nextGroup = item;
        this.tipsVisible = true;
        return;
      }
      if (item.id != this.selectGroup.id) {
        this.selectGroup = JSON.parse(JSON.stringify(item));
        this.operateGroup = JSON.parse(JSON.stringify(item));
        this.getGroupPeople();
      }
    },
    addGroupClick() {
      this.addGroup = true;
      this.cannoSubmit = false;
    },
    addGroupClose() {
      this.addGroup = false;
      this.$refs['addForm'].resetFields();
    },
    deleteGroupClick(item) {
      this.operateGroup = JSON.parse(JSON.stringify(item));
      this.deleteGroup = true;
    },
    deleteGroupClose() {
      this.deleteGroup = false;
    },
    tipClose() {
      this.tipsVisible = false;
    },
    getGroupList(flag = false) {
      TeamGroupApi.getGroupInfo().then((res) => {
        if (res.data.code === 200) {
          this.groupList = res.data.data;
          this.filterList = res.data.data;
          // console.log("flag");
          // console.log(flag);
          // console.log(this.selectGroup);
          if (flag) {
            this.groupList.forEach((element) => {
              if (element.id === this.nextGroup.id) {
                this.selectGroup = JSON.parse(JSON.stringify(element));
              }
            });
            this.tipClose();
          } else {
            if (!this.selectGroup.name) {
              this.selectGroup = JSON.parse(JSON.stringify(this.groupList[0]));
            } else {
              let have = false;
              this.groupList.forEach((element) => {
                if (element.id === this.selectGroup.id) {
                  have = true;
                  this.selectGroup = JSON.parse(JSON.stringify(element));
                }
              });
              if (!have) {
                this.selectGroup = this.groupList[0];
              }
            }
          }
          this.operateGroup = JSON.parse(JSON.stringify(this.selectGroup));
          this.getGroupPeople();
        }
      });
    },
    deleteGroupSubmit() {
      TeamGroupApi.deleteGroupInfo({
        id: this.operateGroup.id,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: '删除班组成功！',
            type: 'success',
          });
          this.getGroupList();
          this.deleteGroup = false;
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },
    addGroupSubmit() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          if (this.selectGroupManagerList.length === 0) {
            this.$message.error('请选择班组长');
            return;
          }

          this.addForm.groupEmployeeId = this.selectGroupManagerList[0].id;

          TeamGroupApi.addGroupInfo(this.addForm).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: '新增班组成功！',
                type: 'success',
              });
              this.$refs['addForm'].resetFields();
              this.getGroupList();
              this.addGroup = false;
            }
          });
        } else {
          this.$message({
            message: '请输入班组名称！',
            type: 'error',
          });
        }
      });
    },
    checkName() {
      TeamGroupApi.checkGroupName({
        name: this.addForm.name,
      }).then((res) => {
        if (res.data.code === 200) {
          //   this.cannoSubmit = false;
        } else {
          //   this.cannoSubmit = true;
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },
    getGroupPeople() {
      this.query.groupId = this.selectGroup.id;
      TeamGroupApi.getEmployeeByGroupId(this.query).then((res) => {
        if (res.data.code === 200) {
          this.peopleList = res.data.data.records;
          // this.selectPeopleList = JSON.parse(
          //   JSON.stringify(res.data.data.records)
          // );
          // console.log("this.selectPeopleList1");
          // console.log(this.selectPeopleList);
          // console.log("this.selectPeopleList1");
          this.total = res.data.data.total;
          this.leaderList = [];
          this.peopleList.forEach((item) => {
            if (item.managerMark === 1) {
              this.leaderList.push(item);
            }
          });
        }
      });
    },
    searchPeople() {
      this.query.pageDto.current = 0;
      this.getGroupPeople();
    },
    handleCurrentChange(val) {
      this.query.pageDto.current = val;
      this.getGroupPeople();
    },
    handleSizeChange(val) {
      this.query.pageDto.size = val;
      this.query.pageDto.current = 0;
      this.getGroupPeople();
    },

    openAddGroupManager() {
      //选择班组
      this.addGroupManagerDialogVisible = true;
    },
    closeGroupManagerDialog() {
      this.addGroupManagerDialogVisible = false;
    },
    submitGroupManager(employeeRoleList) {
      this.selectGroupManagerList = employeeRoleList;
    },
  },
};
</script>

<style lang="scss" scoped>
.teamGroup {
  display: flex;
  flex-direction: row;

  .left {
    width: 200px;
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
    height: 100%;

    .fzList {
      height: calc(100% - 100px);
      overflow: hidden;
      overflow-y: auto;

      .listItem {
        height: 40px;
        line-height: 40px;
        cursor: pointer;

        .showDelete {
          display: none;
        }
      }
      .listItemChoose {
        background-color: #d9ecff;
      }
      .listItem:hover {
        background-color: #d9ecff;
        .showDelete {
          display: inline-block;
        }
      }
    }
  }

  .right {
    flex: 1;
    background-color: white;
    padding: 10px;
    overflow: hidden;
    overflow-x: auto;

    .info {
      .el-button {
        vertical-align: top;
      }

      .manager {
        display: inline-block;
        width: auto; //400px;
        min-width: 80px;
        min-height: 40px;
        padding: 0 6px 0 0;
        border: 1px dashed #ccc;

        .peopleItem {
          width: auto;
          display: inline-block;
          height: 20px;
          line-height: 20px;
          padding: 0 6px;
          background-color: #ccc;
          border-radius: 10px;
          margin-left: 6px;
        }
      }
    }
  }

  .inline {
    display: inline-block;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; //溢出不换行
  }

  .height50 {
    height: 50px;
    line-height: 50px;
  }

  .borderBottom {
    border-bottom: 1px solid #ccc;
  }

  .floatRight {
    float: right;
  }
}
</style>
